



angular.module('theme.core.filters')
.filter('numberpl', function($filter) {
	var numberFilter = $filter('number');
	return function(amount, fractionsize) {
		var str = numberFilter(amount, fractionsize);
		/*
		if (typeof str == "string") {
			str = str.replace(/,/, ' ');
			str = str.replace(/\./, ',');
		}
		*/
		return str;
	}
})
